import { iconAdd } from '@cube3/ui/src/icons/GeneralSVG';
import {
  archivedProjectTooltip,
  readOnlyProjectTooltip
} from '../../../../CommandBar/factories/tooltip';
import {
  ButtonFactory,
  ButtonFactoryConfig
} from '../../../../CommandBar/useButtonConfig';

export const attachContractButtonFactory = (
  onClick: () => void
): ButtonFactory => {
  const f = (config: ButtonFactoryConfig) => {
    const { canWriteContract } = config.privileges;
    const { isProjectArchived, isProjectRoleReadOnly } = config;

    const disabledReason = (() => {
      switch (true) {
        case !canWriteContract:
          return 'This account has no permission to attach contract';
        case isProjectRoleReadOnly:
          return readOnlyProjectTooltip;
        case isProjectArchived:
          return archivedProjectTooltip;
        default:
          return undefined;
      }
    })();

    return {
      title: 'Attach Contract',
      visible: true,
      disabled: !canWriteContract || isProjectRoleReadOnly || isProjectArchived,
      disabledReason,
      icon: iconAdd,
      onClick: onClick
    };
  };

  return {
    factory: f
  };
};
